import BaseLayer from "./BaseLayer";
import {plotFftFourDTextUnit, transformFFTFourDData} from "../utils/map_utils";

class FFTFourDT1Text extends BaseLayer {
    id = "fft4dT1Text";
    label = "FFT 4D T1 Text";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {normBlurValsFourdTake1, textColor, textSize} = this.props;
    
        let dataArray = transformFFTFourDData(normBlurValsFourdTake1, this.props.slide);
        let margin = 2 / 10;
        let sizeOfMarker = 0.3;
        for (let fftVals in dataArray[0]) {
            let x = parseInt(fftVals.split('y')[0].split('x')[1]);
            let y = parseInt(fftVals.split('y')[1].split('.' + this.props.slide.img_type)[0]);
            plotFftFourDTextUnit(dataArray[0][fftVals], this.props.slide, x, y, margin, sizeOfMarker,
                this.layer.getSource(), textColor, textSize);
        }
        resolve();
    });
}

export default FFTFourDT1Text;
